import React from 'react'
import styles from './Plot.scss';

class TreeMapPlot extends React.Component {
  render(){
    return (
      <div className={styles.outer}>
        Tree map coming soon&hellip;
      </div>
    )
  }
}
export default TreeMapPlot
